export default {
  首页: "表紙",
  资产: "資産",
  币币: "通貨",
  快捷买币: "P2P トレード",
  "支持多种方式购买，购买更简单":
    "複数の購入方法をサポートし、よりシンプルに購入",
  语言设置: "言語設定",
  确认恢复: "回復を確認",
  "输入邮箱，方便我们联系您": "メールアドレスを入力してください。",
  划转: "移行",
  行情: "市場",
  "24H成交": "24H 取引",
  累计收益: "累積収入",
  充值时间: "入金時間",
  到期时间: "有効期限",
  数量: "量",
  操作: "操作する",
  资产信息: "資産情報",
  复制地址: "アドレスをコピー",
  链名称: "チェーン名",
  充值地址: "リチャージアドレス",
  收款地址: "お支払い住所",
  账单: "明細書",
  提现金额: "出金金額",
  接收地址: "受信アドレス",
  交易密码: "取引パスワード",
  提现全部: "すべて撤回",
  保存图片: "画像を保存する",
  输入您的交易密码: "取引パスワード",
  确定: "もちろん",
  地址: "住所",
  注册时间: "サインタイム",
  取消: "キャンセル",
  是否划转: "転送するかどうか",
  登录: "ログイン",
  我的地址: "私のアドレス",
  登录密码和交易密码: "ログインパスワードと取引パスワード",
  注册: "登録",
  密码: "パスワード",
  设置密码: "パスワードを設定してください",
  重复密码: "パスワードを再度入力してください。",
  新密码: "新しいパスワード",
  确认新密码: "新しいパスワードを確認する",
  充值: "デポジット",
  充值货币: "デポジット",
  合约账户充值: "先物口座のリチャージ",
  账户充值: "アカウントのリチャージ",
  其他: "他の",
  我的邀请码: "招待コード",
  提现: "撤退",
  客服: "お客様",
  持有详情: "開催詳細",
  请输入内容: "内容を入力してください",
  邀请好友来领取奖励: "友達を招待して報酬を受け取りましょう",
  复制链接: "コピー",
  重复设置新的密码: "新しいパスワードの設定を繰り返す",
  保存: "保存",
  我的: "私の",
  "邮箱/手机号": "メール・携帯電話番号",
  备注: "述べる",
  地址管理: "私のアドレス",
  我的团队: "チーム",
  联系我们: "お問い合わせ",
  竭诚为您服务: "よろしくお願いいたします。",
  提取收益: "引き出し収入",
  带给我的收益: "私の利益",
  添加: "追加",
  名称: "名前",
  添加地址: "住所を追加",
  修改地址: "住所を変更する",
  可提现: "出金可用",
  安全中心: "セキュリティセンター",
  收益划转: "所得移転",
  通知中心: "通知センター",
  "累计收益:": "累積収益:",
  注册用户: "登録ユーザー",
  奖励规则: "報酬のルール",
  帮助反馈: "ヘルプ フィードバック",
  邀请好友: "友達を招待",
  恢复身份: "ID の復元",
  选择语言: "言語を選択",
  设置新的密码: "新しいパスワードを設定",
  暂无活动: "活動なし",
  "月增长量(+)": "毎月の成長 (+)",
  可提取: "引き出し可能額",
  反馈类型: "フィードバックの種類",
  赠送: "与える",
  已经复制: "コピーされました",
  保存成功: "正常に保存されました",
  划转成功: "転送の成功",
  过期: "期限切れ",
  提交成功: "正常に送信されました",
  "服务器繁忙，稍后在试": "サーバーがビジーです。後で試してください",
  全部: "全て",
  一级: "レベル 1",
  二级: "レベル 2",
  三级: "レベル 3",
  级: "クラス",
  删除成功: "正常に削除されました",
  选择地址: "住所を選択",
  不再提醒: "リマインダーなし",
  "最小充值金额：": "最小リチャージ:",
  选择币种: "最小リチャージ",
  输入投资金额: "投資額",
  输入账户密码: "パスワード",
  投资: "投資",
  订单编号: "オーダーID",
  投资周期: "サイクル",
  投资资金: "資金",
  投资时间: "時間",
  状态: "州",
  投资中: "投資中",
  已到期: "期限切れ",
  暂无数据: "データなし",
  转入: "転入",
  邮箱: "郵便",
  请输入邮箱: "Eメール",
  请输入格式正确的邮箱: "電子メールアドレス",
  请输入验证码: "検証コード",
  获取验证码: "Get code",
  请输入邀请码: "招待コード",
  今天: "今日",
  昨天: "昨日",
  最近七天: "過去 7 日間",
  邀请: "邀请",
  购买数量: "購入数量",
  产品详情: "製品详情",
  币种: "通貨",
  利息币种: "金利通货",
  理财类型: "财务类型",
  产品费率: "产品率",
  进行中: "処理",
  每天: "毎日",
  请输入搜索关键词: "キーワードで検索してください",
  通知: "知らせ",
  查看更多: "もっと",
  理财宝: "HODLと獲得",
  周期: "サイクル",
  年利率: "APR",
  更多产品: "その他の製品",
  灵活存取: "柔軟な預金",
  稳定收益: "安定したリターン",
  合约指南: "ヘルプセンター",
  资金划转出: "资金划转出",
  矿池收益: "マイニングプールの収益",
  提现手续费: "出金手数料",
  冻结资金: "資金を凍結する",
  解冻资金: "資金の凍結を解除",
  闪兑支出: "フラッシュ支出",
  闪兑收入: "フラッシュ為替収入",
  闪兑手续费: "フラッシュ交換手数料",
  合约支出: "契約金",
  合约收入: "合约收入",
  输入的金额不可大于可用金额:
    "入力した金額は、利用可能な金額を超えることはできません",
  全部兑换成功: "すべて正常に引き換えられました",
  返回: "戻る",
  查看历史: "履歴を見る",
  闪兑历史: "フラッシュ履歴",
  支付: "支払い",
  获取: "入手",
  时间: "時間",
  手续费: "手数料",
  折扣: "割引",
  价格: "価格",
  逐仓: "制御位置",
  全仓: "すべてのポジション",
  市价委托: "成行注文",
  限价委托: "指値注文",
  请输入本金: "金額を入力します",
  请输入价格: "価格を入力してください",
  "可做空/做多": "ショート/ロング",
  设置止盈止损: "TP/SL",
  止盈价: "Est. TP",
  止损价: "Est. SL",
  成本: "料金",
  做多: "長く行く",
  做空: "短い",
  仓位信息: "位置情報",
  一键平仓: "速い近い",
  永续: "持続可能な",
  浮动盈亏: "P&L",
  平仓: "近い",
  反向开仓: "逆開き",
  一键撤销: "ワンクリックで元に戻す",
  倍杠杆: "x レバー",
  执行价格: "権利行使価格",
  委托数量: "注文数",
  保证金: "マージン",
  成交价: "最終価格",
  创建时间: "作成時間",
  撤销: "取り消す",
  合约市场: "契約市場",
  交易方向: "取引方向",
  委托价格: "注文価格",
  委托金额: "手数料額",
  资金费率: "資金調達率",
  "多方和空方交易者支付的定期费用，每8小时结算一次。":
    "ロングおよびショート トレーダーが支払う定期的な手数料で、8 時間ごとに決済されます。.",
  "资金费率为正，多方向空方支付资金费用。":
    "資金調達率はプラスで、ロングサイドはショートサイドに資金調達手数料を支払う.",
  "资金费率为负，空方向多方支付资金费用。":
    "資金調達率はマイナスで、ショートサイドはマルチパーティに資金調達手数料を支払う.",
  "确定反向开仓吗？反向开仓将以当期相反 的仓位进行买入":
    "逆にポジションをオープンしてもよろしいですか?リバース オープン ポジションは、現在の反対ポジションで購入されます",
  "仓位止盈/止损": "ポジションテイクプロフィット ・ストップロス",
  合约名称: "契約する",
  开仓价格: "始値",
  指数价格: "指数価格",
  止盈设置: "テイクプロフィット設定",
  请输入止盈价: "テイクプロフィット価格を入力してください",
  "当指数价格触达*时，将会触发委托平仓":
    "インデックス価格が {0} に達すると、ポジションを決済する注文がトリガーされます",
  预计盈亏: "推定損益",
  当前仓位: "現在位置",
  平仓金额: "清算金額",
  仓位模式: "位置モード",
  全仓模式: "フルウェアハウスモード",
  "合约账户中的所有可用资金视作为可用保证金， 当仓位亏损超过了账户余额才会爆仓强平，并将损失所有 保证金和仓位，请注意":
    "コントラクト口座で利用可能なすべての資金は、ポジションの損失が口座残高を超えた場合にのみ、フリーマージンと見なされます。清算されて強制的に清算され、すべての証拠金とポジションが失われますのでご注意ください",
  逐仓模式: "制御位置モード",
  "会使合约账户中的一定数量保证金被分配到仓位上。如果保证金亏损低于维持保证金的水平，仓位被强平。在逐仓模式下，您可以为这个仓位增加和减少保证金。":
    "これにより、コントラクト アカウントの一定量の証拠金がポジションに割り当てられます。差損が維持よりも小さい場合証拠金レベル、ポジションは清算されます。分離モードでは、このポジションの証拠金を増減できます.",
  "是否撤销？": "取り消されるか?",
  "是否一键撤销？": "ワンクリックでキャンセルするかどうか?",
  "是否一键平仓？": "ワンクリックでポジションを決済するかどうか?",
  持仓保证金: "ポジションマージン",
  风险率: "危険",
  未实现盈亏: "未実現 P&L",
  可用保证金: "フリーマージン",
  净值: "純資産",
  账户余额: "バランス",
  合约计算器: "契約計算機",
  交易记录: "取引記録",
  "*倍杠杆": "{num} x",
  "平仓盈亏：": "P&L:",
  时间筛选: "時間フィルター",
  仓位类型: "ポジションタイプ",
  订单状态: "注文の状況",
  订单类型: "注文タイプ",
  平仓价格: "終値",
  持仓数量: "ポジション数",
  "手续费(%)": "手数料 (%)",
  平仓时间: "閉店時間",
  平仓类型: "密閉型",
  手动平仓: "手動",
  强制平仓: "強制清算",
  近1天: "1 日",
  近7天: "7 日",
  近30天: "30 日",
  近180天: "180 日",
  持仓: "オープンポジション",
  已取消: "キャンセル",
  分时: "時間",
  "24H额(USDT)": "24H amount (USDT)",
  "24H低": "24H low",
  "24H量(BTC)": "24H volume (BTC)",
  "24H高": "24H high",
  "10秒": "10秒",
  "30秒": "30秒",
  "1分": "1 point",
  "3分": "3 points",
  "5分": "5 points",
  "30分": "30 points",
  "1小时": "1 hour",
  "4小时": "4 hours",
  "8小时": "8 hours",
  "1天": "1 日",
  "1周": "1 周",
  "1月": "1 月",
  单向持仓: "一方通行の立場",
  杠杆: "レバー",
  仓位: "位置",
  计算结果: "計算結果",
  盈亏: "利益と損失",
  收益率: "利益率",
  计算结果仅供参考: "計算結果は参考値ですそれだけ",
  成交后仓位大小: "取引後のポジションサイズ",
  "计算结果仅供参考,实际结果可能因费率差异":
    "計算結果は参考用であり、実際の結果はレートの違いにより異なる場合があります",
  目标价格: "目標価格",
  开始计算: "开始计算",
  强平价格: "强平价格",
  "充值前，请认真核对充值的链名称，充值错误无法找回资产*最小充值金额为*；少于此金额平台将无法确认到账，请不要向此地址充值*之外的资产，否则将无法找回资产，请不要直接提现众筹或者ICO地址，平台不会代理币的发放。":
    "リチャージする前に、リチャージ チェーンの名前をよく確認してください。リチャージが間違っている場合、資産を取得できません。*最低リチャージ額は*であり、金額がこの額未満の場合、プラットフォームは確認できません。 * 以外の資産をこのアドレスにリチャージしないでください。そうしないと、資産を回収することができなくなります。資産を取得するには、クラウドファンディングまたは ICO アドレスを直接出金しないでください。プラットフォームはエージェントとしてコインを発行しません。.",
  "最小输入*": "最小入力 {0}",
  "最小提币数量为*，提币手续费将从你的提款金额中扣除。提币前请确认核对收款地址，不要将*提现至*以外的地址，否则无法找回资产。请不要直接提现众筹或者ICO地址，平台不会处理代币的发放。":
    "最低出金額は*で、出金手数料は出金金額から差し引かれます。コインを出金する前に、受取アドレスを確認・確認し、※※以外のアドレスに出金しないでください。資産を回収できません。クラウドファンディングから直接撤退したり、ICO アドレス、プラットフォームはトークンの発行を処理しません.",
  退出登录: "サインアウト",
  加仓: "追加",
  新增仓位: "追加",
  输入加仓金额: "加算量",
  "当前可用:": "現在の金額:",
  资产账单: "資産手形",
  保存二维码: "保存 QR code",
  温馨提示: "親切なヒント",
  "请注意：您当前使用的网络": "注: 現在のネットワーク",
  输入提现地址: "出金先住所を入力",
  "可用金额：": "利用可能額:",
  输入资产密码: "資産暗号",
  可用手续费: "利用可能な手数料",
  "折扣%": "割引%",
  实扣手续费: "実費控除額",
  实际到账: "実際の領収書",
  未设置资产密码: "資産パスワードが設定されていません",
  "为了您的资产安全，请设置资产密码后再来提现。":
    "資産のセキュリティのため、出金する前に資産パスワードを設定してください.",
  热榜: "熱い",
  涨幅榜: "上昇",
  跌幅榜: "却下",
  成交额榜: "取引をする",
  关于我们: "私たちに関しては",
  登录密码: "ログインパスワード",
  设置: "設定",
  资产密码: "資産暗号",
  修改登录密码: "ログインパスワードの変更",
  原密码: "以前のパスワード",
  请输入新密码: "新しいパスワードを入力",
  请输入原密码: "元のパスワードを入力してください",
  确认密码: "パスワードを認証する",
  确定修改: "変更してもOK",
  修改资产密码: "資産パスワードの変更",
  验证码: "検証コード",
  资产密码使用提示: "資産パスワードの使用に関するヒント",
  "资产密码用于转移、提取资产和交易。":
    "資産暗号 は、資産の譲渡、引き出し、および取引に使用されます.",
  "创建与登录密码不同的资产密码。":
    "ログインパスワードとは異なるアセットパスワードを作成する.",
  "定期更改您的资产密码。": "資産パスワードを定期的に変更する.",
  提币历史: "出金履歴",
  "金额/余额": "金額・残高",
  "手续费/折扣": "手数料・割引",
  自选: "オプション",
  现货: "スポットグッズ",
  市价: "市場価格",
  止损设置: "ストップロス設定",
  合约K线图: "コントラクト K ライン チャート",
  "24H量": "24H volume",
  "24H额": "24H amount",
  合作指南: "協力ガイド",
  盈亏计算: "P&L",
  当前可用: "現在の金額",
  请输入加仓金额: "加算量",
  请重新输入加仓金额: "増額額を再入力する",
  平仓数量: "クローズポジション数",
  欢迎登录: "ログイン ",
  "忘记密码?": "パスワードをお忘れですか?",
  "还没有账号？": "まだアカウントを持っていません?",
  立即注册: "今すぐサインアップ",
  繁體中文: "繁体字中国語",
  找回密码: "パスワードを取得する",
  下一步: "次のステップ",
  注册账户: "アカウント登録",
  "请输入邀请码(选填)": "招待コード (オプション)",
  邀请豪礼: "招待ハオリ",
  "24小时邀请好友排名": "24時間招待フレンドランキング",
  "*人": "{0}",
  "差*人": "{0}Gap",
  "已超过10万人，每月轻松赚钱":
    "100,000人以上の人がいて、毎月簡単にお金を稼いでいます",
  最高: "Highest",
  邀请链接: "Link",
  "平台和您共享好友在平台（现货、合约、杠杆、闪兑）所产生的手续费":
    "プラットフォームとあなたは、プラットフォーム上の友人によって生成された料金を共有します (スポット、契約、レバレッジ、フラッシュ交換)",
  平台和您一起分享手续费: "料金を一緒に分担する",
  "*级": "{0}level",
  规则: "ルール",
  我的好友: "私の親友",
  好友详情: "友達の詳細",
  获得好友佣金方案: "友達になる コミッション プログラム",
  我的等级: "私のレベル",
  我的邀请数据: "私の招待データ",
  当前等级: "現在のレベル",
  平台奖励您: "プラットフォーム報酬",
  最高可获取平台奖励: "最高のプラットフォーム報酬を獲得できます",
  邀请规则: "招待ルール",
  "邀请*级有效好友": "クラスを招待する * 有効な友達",
  好友等级: "友達 level",
  人: "人々",
  奖金派送: "ボーナス配信",
  平台奖励: "プラットフォーム報酬",
  "最终解释权归平台所有，若发现异常获取平台奖励，将会扣除所有的奖励，并且冻结账户，资产的损失将无法找回。":
    "最終的な解釈権はプラットフォームに属し、プラットフォームの報酬が異常に取得されたことが判明した場合、すべての報酬が差し引かれ、アカウントが凍結され、資産の損失は回復されません。.",
  "您的账户必须是有效账户，平台判定有效账户条件为（账户充值任何币种）最小* USDT的价值。":
    "あなたのアカウントは有効なアカウントでなければなりません. プラットフォームは、有効なアカウントの条件が (任意の通貨でのアカウントのリチャージ) 最小 * USDT 値であると判断します.",
  "您邀请的好友，必须是有效下级，平台判定有效下级为（账户充值任何币种）最小* USDT的价值。":
    "招待する友達は有効な部下でなければなりません. プラットフォームは、有効な部下が (任意の通貨でのアカウントのリチャージ) 最小 * USDT 値であると判断します.",
  "邀请人和被邀请者的账号不能同属于一个IP。":
    "招待者と招待者のアカウントが同じ IP に属することはできません.",
  "VIP等级由您邀请的*级好友的人数作为考核。":
    "VIPレベルは、あなたが招待したトップレベルの友達の数によって評価されます.",
  佣金成分: "コミッションコンポーネント",
  收益统计: "所得統計",
  昨日收益: "昨日の収益",
  月收益: "月収",
  获取收益: "メリットを得る",
  "总收益：": "総収入:",
  "*级好友": "{0}level 友達",
  理财购买: "金融購入",
  期限: "残り日数",
  可用金额: "利用可能額",
  预估收益: "推定収益額",
  申购上限: "購読制限",
  项目剩余: "プロジェクトの残り",
  "买入后预计*(SGT)开始计算收益。":
    "予想*(SGT) は購入後に収益の計算を開始します.",
  计息日: "利息の日付",
  申购日: "購読日",
  到账日: "到着日",
  到期自动续投: "有効期限後の自動更新",
  申购: "サブスクリプション",
  搜索理财项目: "金融プログラムの検索",
  超高年化随心选: "超高年率の選択肢",
  "自由选择理财币种，稳定超额收益":
    "超過リターンを安定させるためのウェルスマネジメント通貨の自由な選択",
  理财总资产: "ウェルスマネジメント資産合計",
  累计收益: "累計所得",
  申购数量: "購入数量",
  立即购买: "今買う",
  年化收益率: "APR",
  理财订单: "財務書類",
  持有: "所有",
  申购份额: "サブスクリプションシェア",
  到账日期: "到着日",
  申购成功: "サブスクリプションは成功です",
  到期: "到着日",
  是否选择做多: "もっとやることを選びますか",
  "可用余额为0 不能操作": "利用可能残高が0で運用不可",
  福利中心: "福祉センター",
  奖励记录: "報酬実績",
  我获取到的奖励: "私が得た報酬",
  总价值: "総価値",
  新手任务: "初心者タスク",
  身份认证: "認証",
  身份验证: "本人確認",
  去验证: "検証します",
  审核中: "審査中",
  已验证: "検証済み",
  认证失败: "認証に失敗しました",
  基础认证: "基本認証",
  "请注意认证信息一经验证不能修改，务必填写准确信息":
    "認証情報は一度確認すると変更できませんので、正しい情報を入力してください。",
  "国家/地区": "国・地域",
  请选择: "選んでください",
  证件类型: "証明書の種類",
  证件编码: "文書コード",
  身份证: "IDカード",
  护照: "パスポート",
  驾驶证: "運転免許証",
  请输入编码: "コードを入力してください",
  名字: "名前",
  请输入: "入ってください",
  中间名: "ミドルネーム",
  选填: "オプション",
  姓氏: "苗字",
  中国: "China",
  身份上传: "ID のアップロード",
  上传身份证: "アップロード ID",
  "以上材料需要用JPG/JPEG/PNG格式上传，并且保证照片的清晰边角完整，亮度均匀。且大小不超过*M。":
    "上記の素材は JPG/JPEG/PNG 形式でアップロードする必要があり、写真の端と角がはっきりしていて、明るさが均一であることを確認してください。サイズが*Mを超えない.",
  确定提交: "提出を確認する",
  去认证: "認証解除",
  挑战任务: "チャレンジミッション",
  注册认证任务: "認定タスクに登録する",
  完成注册认证即可领取: "登録証明が完了したら、受け取ることができます",
  领取奖励: "受賞",
  新人豪礼: "新人の贈り物",
  "参与人数：": "参加人数:",
  条件: "調子",
  入金量: "入金額",
  完成: "終了",
  任务奖励: "ミッション報酬",
  距任务更新: "タスクから更新",
  "条件：": "調子:",
  活动规则: "活動のルール",
  奖励明细: "報酬の詳細",
  已获得: "得られた",
  交易奖励: "取引報酬",
  Win奖励: "報酬を獲得",
  已领取: "受け取った",
  亏损金额超过: "損失額が上回る",
  单笔开仓金额超过: "1 つのオープン ポジションの金額が",
  交易量: "取引量",
  待完成: "完成予定",
  入金: "デポジット",
  盈利金额超过: "利益額超過",
  开仓金额: "ポジションを開く金額",
  开仓金: "ポジションを開く金額",
  盈利: "利益",
  亏损: "損失",
  领取: "受け取る",
  未领取: "不慣れな",
  待领取: "待领取",
  再交易: "再取引",
  即可获得: "取得するため",
  领取成功: "正常に受信されました",
  "1、所有的活动都会按照活动最后的时间进行统计收益过期后将无效。":
    "1、すべての活動は活動の最後の時間に従ってカウントされ、有効期限が切れると収入は無効になります。.",
  "2、获得的收益会发放到您的赏金账户中，你可以随时根据您的需要进行兑换和提现。":
    "2. 得られた収入は報奨金アカウントに分配され、必要に応じていつでも交換および引き出しできます。.",
  "3、获取的到的奖励币种类型根据任务按类型发放。":
    "3. 獲得できる報酬通貨の種類は、タスクの種類に応じて発行されます.",
  "4、最终解释权归平台所有，若发现存在异常手段套利平台的任务奖金，平台有权冻结并且清除您获取的收益。":
    "4. 最終的な解釈権はプラットフォームに属し、プラットフォームのタスクボーナスを裁定する異常な手段があることが判明した場合、プラットフォームはあなたが得た収入を凍結して清算する権利を有します。.",
  成长学院: "ヘルプ",
  "区块链 & 加密货币": "ブロックチェーンと暗号通貨",
  "您的加密货币一站式指南，我们带您开启加密货币之路。":
    "暗号通貨へのワンストップ ガイド、暗号通貨への道をご案内します.",
  "全仓合约定单的全部保证金。": "クロス コントラクト注文の完全証拠金",
  "(账户余额+(浮动盈亏-手续费-过夜费)=净值/已用保证金*100":
    "(バランス +(未実現損益 - 手数料 - オーバーナイト料金) = 新しい価値 / 使用済みマージン * 100",
  "浮动盈亏会直接影响”可用保证金“，当未实现盈亏增加，可用保证金将会增加，未实现盈亏减少，可用保证金同样也会减少。":
    "変動損益は「利用可能証拠金」に直接影響し、未実現損益が増加すると、利用可能証拠金が増加し、未実現損益が減少し、利用可能証拠金も減少します。.",
  "账户余额-(已用保证金)+(浮动盈亏-手续费-过夜费)":
    "口座残高 - (使用済み証拠金) + (変動損益 - 手数料 - オーバーナイト手数料)",
  "注:可继续用于开仓的保证金。":
    "注: ポジションを開くために引き続き使用できる証拠金.",
  "账户余额+(浮动盈亏-手续费-过夜费)":
    "口座残高＋（変動損益－手数料－オーバーナイト手数料）",
  "注:当前的资金结余。": "現在の資金残高.",
  "指的是合约账户的全部余额，包含不可用余额。":
    "利用不可残高を含む契約口座の全残高を指します.",
  "注:风险率越高，风险越低，风险率越低，风险越高。":
    "注：高いほどリスク率が低いほどリスクが低く、リスク率が低いほどリスクが高くなります。",
  该功能尚未开发: "この機能は開発されていません",
  重置密码: "パスワードを再設定する",
  "请输入为8-20位，必须包含字母、数字和特殊字符":
    "8 ～ 20 文字で入力してください。文字、数字、特殊文字を含める必要があります",
  修改成功: "正常に変更されました",
  输入验证码: "検証コード",
  输入密码: "パスワード",
  详情说明: "詳細",
  已售罄: "完売",
  剩余期限: "残り期間",
  限期: "締め切り",
  闪兑货币选择: "フラッシュ通貨の選択",
  地区选择: "地域選択",
  "搜索国家/地区": "国を検索",
  "身份信息已提交，将在*小时内审核完成":
    "ID 情報が送信されました。{0} 時間以内に審査されます",
  "选择国家/地区": "国を検索",
  "止盈价格需高于*": "テイクプロフィット価格はより高くなければなりません*",
  "止损价格需低于*": "ストップロス価格は以下より低くなければなりません*",
  "止盈价格需低于*":
    "テイクプロフィット価格は以下よりも低くなければなりません*",
  "止损价格需高于*": "ストップロス価格はより高くなければなりません*",
  教程详情: "チュートリアルの詳細",
  请输入止损价: "ストップロス価格を入力してください",
  活期: "フレキシブル",
  赎回后立即到账: "換金直後",
  赎回: "償還",
  赎回理财: "償還資産",
  是否赎回当前的理财订单: "現在のウェルスマネジメント注文を償還するかどうか",
  维护: "メンテナンス",
  "系统正在维护中……": "システムはメンテナンス中です......",
  合约: "契約する",
  闪电兑换: "両替",
  流水挖矿: "流水採掘",
  邀请豪礼: "招待ハオリ",
  计算器: "電卓r",
  最新价: "最新の価格",
  涨跌幅: "見積もり変更",
  关注币种添加自选: "選択した通貨",
  一键添加自选: "追加",
  全标已读: "満点読了",
  无消息: "ニュースはありません",
  "暂时还没有收到任何消息通知哦!": "まだ通知を受け取っていません!",
  没有更多数据: "もういや",
  闪兑: "スワップ",
  从: "から",
  "可用余额：": "バランス：",
  至: "に",
  预览兑换结果: "プレビューw",
  闪兑规则: "ルール",
  "市场闪兑可能变动，请以实际到账的金额数量为准。":
    "市場のフラッシュ交換は変更される場合があります。実際の受け取り金額を参照してください。.",
  "对汇兑率由第三方制定，由于兑换成本以及市场波动，您兑换的汇率可能会高于市场的汇率，请仔细确认后进行操作。":
    "為替レートは第三者によって設定されます. 為替コストと市場の変動により、為替レートが市場の為替レートよりも高くなる場合があります. 続行する前に慎重に確認してください..",
  "平台对每笔汇兑收取大约*%的手续费，用于支付在交易所兑换成本。":
    "プラットフォームでは、取引所ごとに約 *% の手数料が請求されます。これは、取引所での交換費用の支払いに使用されます。.",
  确认汇兑: "確認",
  您预估得到: "推定",
  汇兑: "フラッシュスワップ",
  汇兑比例: "交換比率",
  刷新: "リフレッシュ",
  兑换: "両替",
  没有更多了: "もういや",
  搜索币种: "探す",
  可用: "利用可能",
  我知道了: "知る",
  最新价格: "最新の価格",
  确认: "確認",
  最大: "Max",
  "风险率(%)": "リスク率(%)",
  持仓: "持ってる",
  当前委托: "現在の任務",
  合作交易历史记录: "履歴記録",
  重置: "リセット",
  余额: "バランス",
  现货账户: "資金口座",
  合约账户: "契約口座",
  WIN账户: "Win",
  赏金账户: "報奨金",
  总资产折合: "総資産相当",
  今日收益: "今日の収益",
  充币: "デポジット",
  提币: "撤退",
  账户权益: "アカウントエクイティ",
  "数量/类别": "数量/カテゴリー",
  全部币种: "すべてのコイン",
  全部类型: "いろんなタイプ",
  账单信息: "課金情報",
  理财赎回: "金融償還",
  购买理财: "資産管理を購入する",
  收入: "所得",
  支出: "支出",
  到: "に",
  资产划转: "資産譲渡",
  "最少*": "Min*",
  "可用资产：": "利用可能額",
  确认划转: "転送を確認",
  "只有将资产划转至对于的账户才可以进行交易，账户间的划转不收取手续费。":
    "取引は該当する口座に資産を移すことによってのみ実行でき、口座間の移管には手数料はかかりません。.",
  币种账户选择: "通貨口座の選択",
  选择账户: "アカウントを選択",
  划转详情: "転送の詳細",
  划转明细: "転送情報",
  收入账单: "収入情報",
  支出账单: "支出情報",
  金额: "金額",
  总收益: "総収入",
  佣金: "手数料",
  用户名: "ユーザー名",
  "已领取：": "受け取った：",
  "未领取：": "不慣れな：",
  "请选择国家/地区": "国を選択してください",
  请上传身份信息: "身元情報をアップロードしてください",
  请选择证件类型: "書類の種類を選択してください",
  请填写证件编码: "ID番号を入力してください",
  请填写名字: "名前を入力してください",
  请填写姓氏: "姓を入力してください",
  单向持仓: "一方通行の立場",
  投资金额: "投資額",
  天: "日",
  请输入手机号: "電話番号",
  搜索: "探す",
  搜索历史: "検索履歴",
  热门推荐: "熱い",
  "《Xspace Earn协议》": "《Xspace Earn プロトコル》",
  我已了解并同意: "理解し、同意します",
  协议: "プロトコル",
  Xspace官方中文交流群: "Xspace公式中国語グループ",
  Xspace官方英文交流群: "Xspace公式英語交流グループ",
  预计维护至: "期待される",
  更多功能: "もっと",
  下载APP: "ダウンロード",
  理财: "金融",
  推荐: "お勧め",
  Telegram官方中文频道: "Telegram 公式中国語チャンネル",
  Telegram官方英文频道: "テレグラム公式英語チャンネル",
  官方邮箱: "公式メール",
  客服邮箱: "カスタマーサービスの電子メール",
  上述信息最终解释权归官方所有: "上記情報の最終的な解釈権は公式に帰属します",
  IOS版下载: "IOS のダウンロード",
  Android版下载: "Android用ダウンロード",
  "手续费=买入手续费+资金费率+卖出手续费":
    "手数料＝買い手数料＋資金調達率＋売り手数料",
  资金划转: "移行",
  止盈: "TP",
  止损: "SL",
  自动平仓: "自動",
  委托挂单: "委託注文",
  买: "買う",
  卖: "売る",
  "买入/做多": "買い/ロング",
  "卖出/做空": "売り/空売り",
  详情: "詳細",
  浮动涨跌: "上下に浮く",
  最小: "Min",
  充币数量: "充電量",
  请输入充币数量: "充電量",
  支付截图: "支払いのスクリーンショット",
  提交: "参加する",
  上传驾驶证: "運転免許証をアップロード",
  上传护照: "パスポートをアップロード",
  加载中: "読み込み中",
  上传成功: "成功",
  充值历史: "リチャージ履歴",
  合约卖出手续费: "契約料",
  合约买入手续费: "契約料",
  系统加款: "システムアドオン",
  系统减款: "システム削減",
  合约资金费率: "契約資金調達率",
  佣金分成: "コミッションシェア",
  U本位合约: "U契約",
  资产管理: "資産運用管理",
  APP下载: "アプリのダウンロード",
  全球领先的数字理财平台: "世界をリードするデジタル資産管理プラットフォーム",
  "即刻交易比特币、以太坊等上百种数字资产":
    "ビットコインやイーサリアムなど、何百ものデジタル資産を即座に取引",
  "24H涨跌幅": "24H変更",
  查看更多行情: "見積もりをもっと見る",
  近24小时成交量: "過去 24 時間のボリューム",
  "提供数百种币币和合约交易对，以满足多样化的交易需求。 平台在200个国家和地区中有超过2千万用户，是全球领先的数字资产服务平台。":
    "多様な取引ニーズを満たすために、数百の通貨および契約取引ペアを提供します。このプラットフォームには、200 の国と地域に 2,000 万人を超えるユーザーがおり、世界をリードするデジタル資産サービス プラットフォームです。",
  用户国家分布: "ユーザーの国の分布",
  用户数: "ユーザー番号",
  交易对: "取引ペア",
  服务支持: "サービスサポート",
  "随时随地，多平台终端交易":
    "いつでも、どこでも、マルチプラットフォーム端末トランザクション",
  "多终端完美兼容，随时满足各种场景的交易需求。":
    "マルチターミナルは完全に互換性があり、いつでもさまざまなシナリオの取引ニーズを満たすことができます。",
  随时查看实时行情: "いつでもリアルタイムの相場を表示",
  "轻松买卖BTC，ETH，DOGE和其他数字资产":
    "BTC、ETH、DOGE、その他のデジタル資産を簡単に売買",
  获取您关注的加密货币价格变化预警:
    "気になる暗号通貨の価格変動に関するアラートを受け取る",
  "查看比特币现货、期货、期权价格":
    "ビットコインの現物、先物、オプションの価格を見る",
  比较各交易所加密货币价格: "取引所間で暗号通貨の価格を比較する",
  开启您的数字货币之旅: "デジタル通貨の旅を始めましょう",
  快捷购买数字货币: "デジタル通貨をすばやく購入する",
  "使用多种支付方式交易数字货币，安全快捷":
    "さまざまな支払い方法を使用して、デジタル通貨を安全かつ迅速に取引します",
  最优的交易费率: "最高の取引レート",
  "优惠的交易费率，富有竞争力的VIP权益，享受最优品质的服务":
    "優遇取引レート、競争力のある VIP 権利、最高品質のサービスをお楽しみください",
  可信赖的安全保障: "信頼できるセキュリティ",
  "我们复杂的安全措施和SAFU基金保护您的数字资产免受所有风险。":
    "当社の高度なセキュリティ対策と SAFU 資金は、デジタル資産をあらゆるリスクから保護します。",
  交易: "トレード",
  币币市场: "通貨市場",
  "24H成交量": "24時間ボリューム",
  交易所: "交換",
  "24H最高": "最大 24 時間",
  "24H最低": "最低 24 時間",
  永续合约: "無期限契約",
  日涨跌: "毎日の上昇と下降",
  交易深度: "取引深度",
  "资产(合约)": "資産（契約）",
  历史仓位: "歴史的地位",
  兑换记录: "交換記録",
  类型: "タイプ",
  充值记录: "チャージ",
  划转记录: "譲渡記録",
  类别: "カテゴリー",
  历史账单: "歴史的な手形",
  在线充值: "オンラインリチャージ",
  安全设置: "セキュリティ設定",
  用于账户登录使用: "アカウントログイン用",
  用户提现时安全验证使用: "ユーザーが現金を引き出す際のセキュリティ検証と使用",
  验证: "確認",
  万: "万",
  随时随地开启交易: "トレード。 どこでも。",
  "*货币交易所的所有功能尽在你的手中。":
    "{0}の外貨両替機能はすべてあなたの手の中にあります。",
  "下载*货币交易所APP。": "{0} 外貨両替アプリをダウンロードしてください。",
  下载自: "からダウンロード",
  内测版: "クローズドベータ",
  下载: "ダウンロード",
  扫码下载: "スキャンしてダウンロード",
  设置您的资产密码: "資産パスワードを設定する",
  法币: "法定通貨",
  我要买: "私が購入したい",
  我要卖: "売りたい",
  请输入金额: "金額を入力してください",
  汇率: "為替レート",
  获得: "得る",
  支付通道: "支払いチャネル",
  收款通道: "コレクションチャンネル",
  "出售过程需要务必确认好您的收款方式为本人。":
    "販売プロセス中に、支払い方法が自分のものであることを確認する必要があります。",
  当前法币暂不支持交易对可尝试前往提现:
    "現在の法定通貨は取引ペアをサポートしていません。出金を試みることができます",
  前往提现: "キャッシュアウトに行く",
  该法币暂无通道: "現在、この法定通貨のチャネルはありません",
  "正在出售中，请耐心等待": "販売中です、しばらくお待ちください",
  请选择支付通道: "支払いチャネルを選択してください",
  请选择方式: "方法を選択してください",
  法币历史: "フィアットの歴史",
  买币: "コインを買う",
  卖币: "コインを売る",
  失败: "不合格",
  已完成: "完了",
  未付款: "未払い",
  待审核: "審査待ち",
  打款中: "支払う",
  订单详情: "注文詳細",
  联系客服: "カスタマーサービスに連絡する",
  到账金额: "もらった分量",
  通道: "通路",
  收款人: "受取人",
  收款账户: "売掛金",
  "订单出售失败，请查下方失败原因":
    "注文が販売できませんでした。以下の失敗の理由を確認してください",
  失败原因: "失敗の理由",
  您还未进行付款: "支払いを行っていません",
  您已成功购买: "正常に購入されました",
  已取消订单: "注文がキャンセルされました",
  "订单正在审核中，请耐心等待": "注文は審査中です。しばらくお待ちください",
  您已成功出售: "あなたは無事に売れました",
  "订单正在打款中，请耐心等待": "注文は支払い中です。しばらくお待ちください",
  "支付过程需要您前往其他的平台进行支付订单，请注意信息安全。":
    "支払いプロセスでは、他のプラットフォームに移動して注文の支払いを行う必要があります。情報セキュリティに注意してください。",
  当前法币暂不支持交易对可尝试前往充值:
    "現在の法定通貨は取引ペアをサポートしていません。リチャージを試すことができます",
  前往充值: "充電しに行く",
  购买: "買う",
  订单号: "注文番号",
  单价: "単価",
  到账数量: "口座への金額",
  "当前存在未付的订单，是否继续发起新的支付订单？":
    "現在、未払いの注文があります。新しい支払い注文を開始しますか?",
  继续支付: "払い続ける",
  重新下单: "再注文",
  是否确定出售: "確実に売れますか",
  "确定出售后，平台将分配给买家，请耐心等待平台的撮合。":
    "販売が確認された後、プラットフォームが購入者に割り当てられます。プラットフォームが一致するまでしばらくお待ちください。",
  出售: "売る",
  收款方式: "支払方法",
  订单已生成: "注文が生成されました",
  取消订单: "注文をキャンセルする",
  请在: "でお願いします",
  内完成付款: "以内に支払いを完了する",
  "离开平台，登录您指定的支付，转账到卖家的以下账户，并务必在付款中备注：":
    "プラットフォームを離れ、指定した支払いにログインし、以下の売り手のアカウントに送金し、支払いに必ず注意してください。",
  "若付款时未进行备注，卖家将无法确认收款，造成资产损失无法找回。":
    "支払いの際に何も言われなかった場合、売り手は支払いを確認することができず、回収できない資産の損失につながります。",
  "未在规定的时间内付款，订单都将被取消。":
    "規定の時間内に支払いが行われない場合、注文はキャンセルされます。",
  姓名: "名前",
  收款姓名: "支払者名",
  开户支行: "口座開設支店",
  银行卡号: "銀行カード番号",
  "付款后，返回本平台": "支払い後、このプラットフォームに戻ります",
  "请务必点击下方“我已完成付款，通知卖家”按钮":
    "下の「支払いが完了しました。出品者に通知する」ボタンを必ずクリックしてください。",
  未点击卖家不会放款: "クリックしないと、売り手はお金を解放しません",
  交易条款: "取引条件",
  "购买资金来源，必须合法安全的资金，方可交易":
    "資金源を購入するには、取引する前に合法的で安全な資金が必要です",
  "不允许诈骗、传销、赌博或者其他非法资金交易":
    "詐欺、ねずみ講、ギャンブル、またはその他の違法な金融取引は許可されていません",
  "交易完成后，出现资金风险，被冻结或者涉嫌欺诈、传销、赌博的资金，我方将不在向买方放U，并给予退款":
    "取引完了後、資金凍結または詐欺の疑い、ねずみ講、賭博資金の危険性がある場合、購入者にUを解放せず、返金を行います",
  "已付款，通知卖家": "支払い済、販売者に通知",
  "买方当日累计取消*笔订单，将会取消当日购买功能。确定取消该订单吗？":
    "購入者が同日に {0} 件の注文をキャンセルした場合、即日購入機能はキャンセルされます。 この注文をキャンセルしてもよろしいですか？",
  添加收款方式: "お支払い方法を追加する",
  是否删除此收款方式: "この支払い方法を削除するかどうか",
  删除: "消去",
  请选择法币: "法定通貨を選択してください",
  机构名称: "機関名",
  请选择机构: "機関を選択してください",
  "当您出售数字货币时，您选择的收款方式将向买方展示，请确认填写无误。":
    "デジタル通貨を販売すると、選択した支払い方法が購入者に表示されます。正しく入力されていることを確認してください。",
  请选择银行: "銀行を選択してください",
  请输入姓名: "あなたの名前を入力してください",
  账号: "アカウント",
  请输入账号: "アカウントを入力してください",
  收款码: "レシートコード",
  "银行账号/卡号": "銀行口座/カード番号",
  "请输入银行账号/卡号": "銀行口座/カード番号を入力してください",
  "开户支行（选填）": "口座開設支店（任意）",
  请输入开户支行: "口座開設支店を入力してください",
  "加入*官方频道": "{0}公式チャンネルに参加する",
  关于: "約",
  条款: "条項",
  其他: "他の",
  成功: "成功",
  等待: "待つ",
  作废: "空所",
  确认付款: "支払いを確認する",
  "是否已完成付款？若确认付款后，商家将会在*分内进行确认是否收到付款。":
    "支払いは行われましたか？支払いが確認された場合、加盟店は {0} 分以内に支払いが受領されたかどうかを確認します。",
  最大金额: "最高額",
  最小金额: "最小額",
  付款: "支払い",
  法币充值: "法定通貨のリチャージ",
  法币提现: "フィアットの撤退",
  待支付: "支払われる",
  已支付: "有料",
  商户名: "商人名",
  当前没有添加支付方式: "現在、追加された支払い方法はありません",
  添加后再出售: "出品に追加",
  新人大礼包: "新人プレゼント",
  注册即可领取: "登録して受け取る",
  立即领取: "今すぐ入手",
  不再提示: "再度通知しない",
  "该奖励需在APP中领取，请下载APP":
    "報酬はアプリで収集する必要があります。アプリをダウンロードしてください",
  去交易: "トレード",
  期权交易: "オプション取引",
  交易额: "取引金額",
  可用额度: "利用可能なクォータ",
  交易周期: "取引サイクル",
  看涨: "上昇",
  看跌: "秋",
  当前持有: "現在の保有",
  胜率: "勝率",
  "盈利/亏损数": "利益損失",
  累计实现盈亏: "累計損益",
  秒: "秒",
  分: "分",
  小时: "時間",
  天: "日々",
  周: "週",
  下单时间: "注文時間",
  剩余时间: "残り時間",
  买入价: "買取価格",
  结算价: "決済価格",
  实现盈利: "利益",
  结算时间: "決済時間",
  期权: "オプション",
  新手教程: "初心者向けチュートリアル",
  我的订单: "注文",
  赔率: "オッズ",
  全部订单: "すべての注文",
  持有订单: "保留注文",
  历史订单: "注文履歴",
  输入交易额度: "金額を入力してください",
  选择交易周期: "選考期間",
  去注册: "登録",
  冻结: "氷結",
  期权支出: "オプションの支払い",
  期权收入: "オプション収入",
  用户提现: "ユーザー退会",
  "是否购买？": "買いたいですか？",
  购买成功: "成功した購入",
  请签名: "署名してください",
  提交签名: "署名を提出する",
  清空签名: "明確な署名",
  签名审核中: "署名レビュー",
  已提交: "提出した",
  扫一扫下载APP: "アプリをスキャンしてダウンロード",
  新手领取大礼包: "初心者は酒宴を受け取ります",
  注册实名即送彩金: "登録と実名ボーナス",
  交易总额: "総取引",
  资产不足: "不十分な資産",
  "Win账户的资产不足，可从资金账户划转至此账户":
    "Win口座の資産が不足しており、資金口座から当口座へ移管可能",
  Win: "Win",
  在线充值: "オンラインリチャージ",
  比赛: "コンテスト",
  未开始: "始まっていない",
  赛程: "スケジュール",
  赛果: "結果",
  已结束: "以上",
  让球: "Asian handicap",
  进球数: "Over/Under",
  大: "Over",
  小: "Under",
  胜负平: "Win/Lose",
  和局: "引き分けゲーム",
  投注: "賭け",
  下注金额: "ベット額",
  下注: "賭け",
  阵容: "バトルアレイ",
  分析: "分析する",
  输入下注金额: "賭け金を入力",
  下注成功: "成功した賭け",
  投注记录: "賭けの記録",
  未结算: "決済なし",
  已结算: "決済済み",
  流水: "請求の流れ",
  输赢: "勝つか負けるか",
  赛时: "ゲームの時間",
  下注时间: "賭け時間",
  足彩竞猜: "サッカークイズ",
  查看详情: "小切手",
  输: "失う",
  赢: "勝つ",
  主: "ホームチーム",
  客: "アウェイチーム",
  主胜: "ホームチームの勝利",
  客胜: "アウェイチームの勝利",
  平: "描かれた",
  已延期: "遅らせた",
  账号异常: "アカウントの例外",
  全场独赢: "1x2",
  全场让球: "Handicap",
  全场大小: "Over/Under",
  总进球: "合計ゴール",
  拍摄照片要求: "写真の要件",
  标准拍摄: "標準ショット",
  边框缺失: "国境がありません",
  照片模糊: "ぼやけた写真",
  闪光强烈: "強い閃光",
  上传手持证件照: "パスポートの写真をアップロードする",
  上传证件照: "証明写真のアップロード",
  换一张: "一つ変える",
  出生日期: "生年月日",
  请选择出生日期: "生年月日を選択してください",
  "输入下方正确的图形验证后，获取邮箱验证码进行注册":
    "以下の正しいグラフィック検証を入力した後、登録用の電子メール検証コードを取得します",
  "您还剩余*次认证次数，超出次数将无法继续认证":
    "{0} 個の認定資格が残っています。それを過ぎると、認定資格を継続できなくなります",
  上半场: "前半",
  下半场: "後半",
  独赢: "1x2",
  上半场独赢: "前半 1x2",
  下半场独赢: "後半 1x2",
  上半场让球: "前半 Handicap",
  下半场让球: "後半 Asian handicap",
  上半场大小球: "前半 Over/Under",
  下半场大小球: "後半 Over/Under",
  波胆: "Correct Score",
  上半场波胆: "前半 Correct Score",
  下半场波胆: "後半 Correct Score",
  单双: "Odd/Even",
  上半场单双: "前半 Odd/Even",
  下半场单双: "後半 Odd/Even",
  总进球: "Total Goal",
  上半场总进球: "前半 Total Goal",
  下半场总进球: "後半 Total Goal",
  单: "Odd",
  双: "Even",
  中场: "ミッドフィールド",
  "注意：手持证件照请按照此示例图在白纸上书写文字并与证件一起拍摄":
    "注: このサンプル画像に従って白い紙にテキストを書き、ID カードと一緒に写真を撮ってください。",
  "近期发现大量作弊账户，对一批违规账户进行了惩罚。如果有误判为违规账户，请联系在线客服。":
    "最近、多数の不正アカウントが発見され、多数の違法アカウントが処罰されています。 不正なアカウントと判断された場合は、オンラインカスタマーサービスまでご連絡ください。",
  最小下注金额: "最低ベット額",
  参与活动最小下注金额: "イベントに参加するための最低ベット額",
  记住密码: "パスワードを覚える",
  比分: "スコア",
  "您还未登录，请先登录": "ログインしてください",
  立即登录: "ログイン",
  下注限额: "ベットリミット",
  可赢金额: "獲得可能額",
  闪兑详情: "フラッシュの詳細",
  大小球: "Over/Under",
  "由于汇率原因，下注金额和实际下注金额会有误差，请以订单为准。":
    "為替レートにより、ベット額と実際のベット額に差が生じますので、ご注文をご参照ください。",
  开赛时间: "始まる時間",
  足球收入: "サッカー収入",
  足球支出: "サッカーの支出",
  活动详情: "活動内容",
  为世界杯喝彩: "ワールドカップに乾杯",
  我的竞猜: "私の推測",
  "竞猜比赛、有机会瓜分*USDT":
    "ゲームを推測して、{0}USDT を共有するチャンスがあります",
  "瓜分*USDT": "切り分け{0}USDT",
  距离活动结束还有: "距離の終わり",
  我的门票: "私のチケット",
  竞猜结束时间: "終了時間を推測する",
  猜比分: "スコアを推測する",
  "福利派送中，完成任务即可获取门票":
    "福利厚生配布中、タスクを完了してチケットを入手",
  "完成如下任务，可获对应数量门票的参与竞赛":
    "次のタスクを完了すると、対応する数のチケットを獲得して、コンテストに参加できます",
  时: "時間",
  活动: "アクティビティ",
  竞猜记录: "推測記録",
  结果: "結果",
  任务: "仕事",
  去邀请: "招待する",
  "每场比赛的比分竞猜，参与竞猜可瓜分$*美金的奖励。":
    "試合ごとのスコアクイズに参加すると、ドル{0}ドルの奨励金を分割することができます。",
  "参与竞猜需要门票，门票可按照平台的任务进行获得。":
    "クイズに参加するには、プラットフォームのタスクに応じて取得できるチケットが必要です。",
  "竞猜成功后，把竞猜结果的截图发送给客服，客服会把奖金划入您的现货账户，你可以立即提取。":
    "推測が成功した後、推測結果のスクリーンショットをカスタマー サービスに送信すると、カスタマー サービスがボーナスをスポット アカウントに転送し、すぐに引き出すことができます。クイズが成功すると、クイズ結果のスクリーンショットをカスタマーサービスに送信すると、カスタマーサービスはボーナスを資金口座に振り込み、すぐに引き出すことができます。",
  "禁止任何作弊行为、如果发现作弊行为，奖励无效。":
    "不正行為は禁止されており、不正行為が発覚した場合、報酬は無効になります。",
  "完成任务后，点击咨询客服获得门票。":
    "タスクが完了したら、Consult Customer Service をクリックしてチケットを取得します。",
  继续猜: "推測し続ける",
  总单数: "全単数",
  赛事筛选: "イベント上映",
  球队筛选: "チームセレクション",
  总金额: "一時金",
  总流水: "総取引高",
  派奖金额: "ボーナス額",
  下注单数: "奇数に賭ける",
  利润: "利益",
  更多福利: "福祉",
  我的奖金: "私のボーナス",
  未认证: "認定されていません",
  总量: "合計",
  或: "また",
  模拟交易: "デモ取引",
  体验账户不可操作: "エクスペリエンス アカウントが動作しません",
  世界杯比分竞猜: "ワールドカップスコアクイズ",
  "领*USDT起": "{0}USDT から",
  消息: "情報",
  滚球: "ボールを転がす",
  是: "はい",
  不是: "いいえ",
  当前余额: "経常収支",
  KOL招募: "KOL採用",
  本月净输赢: "その月の純勝敗",
  本月佣金: "今月のコミッション",
  佣金比例: "手数料率",
  活跃人数: "アクティブ番号",
  新增下级: "部下を追加",
  登录人数: "ログイン数",
  首存人数: "初回預金者数",
  数据分析: "データ解析",
  人数: "人々の数",
  新注册存款金额: "新規登録入金額",
  老用户存款金额: "旧ユーザー入金額",
  首存金额: "初回入金額",
  快捷入口: "クイックエントリー",
  成员管理: "会員管理",
  财务报表: "財務諸表",
  分红报表: "配当金報告書",
  订单记录: "注文記録",
  VIP专享: "VIP限定",
  推广工具: "プロモーションツール",
  计算规则: "計算規則",
  账变明细: "アカウント変更の詳細",
  成员: "メンバー",
  下级概览: "部下の概要",
  下级成员总计: "下位メンバー合計",
  本月新增: "今月の新作",
  本月活跃会员: "今月のアクティブメンバー",
  今日活跃会员: "今日のアクティブメンバー",
  本月有效活跃: "今月アクティブ",
  活跃成员占比: "アクティブ会員の割合",
  本月活跃: "今月アクティブ",
  今日活跃: "今日もアクティブ",
  下级成员: "年少メンバー",
  会员账号: "メンバーアカウント",
  统计时间: "統計時間",
  筛选: "フィルター",
  存款: "預り金",
  取款: "お金を引き出す",
  总输赢: "総勝敗",
  是否有效用户: "有効なユーザーですか",
  最近登录时间: "最終ログイン時間",
  否: "いいえ",
  开始时间: "開始時間",
  结束时间: "終了時間",
  提取: "エキス",
  总盈亏: "総損益",
  净盈亏: "純損益",
  分红: "配当",
  概览: "概要",
  月度详细数据: "詳細月次データ",
  未发放: "発行されない",
  活跃用户: "アクティブ ユーザー",
  有效新增会员: "新しいメンバーを効果的に追加する",
  冲正后净输赢: "フラッシュ後の純勝敗",
  上月结余: "先月の残高",
  净输赢: "純勝敗",
  "系统每日新加坡时间1:00更新一次报表":
    "システムは毎日シンガポール時間1:00に1回レポートを更新します",
  "报表中数据、总输赢、净输赢中正数表示代理方盈利、负数表示代理方亏损":
    "レポートのデータ、総勝敗数、純勝敗数の正の数値はエージェントの利益を示し、負の数値はエージェントの損失を示します。",
  "佣金数据每天进行更新，仅供参考，并不做实际佣金派发标准":
    "手数料データは毎日更新され、参考用であり、実際の手数料分配基準ではありません",
  选择时间: "選考期間",
  足球: "フットボール",
  投注金额: "賭け金",
  有效订单: "有効な注文",
  下级账户: "下位アカウント",
  待成交: "保留中の取引",
  下单金额: "注文金額",
  订单内容: "注文内容",
  秒数: "秒",
  联赛: "リーグ",
  队伍: "チーム",
  比赛时间: "競技時間",
  玩法: "遊び方",
  等级规则表: "等級規則表",
  等级: "学年",
  活跃会员: "アクティブメンバー",
  最新活跃: "最新のアクティブ",
  额外佣金: "追加手数料",
  "每月按照对应等级的增长标准与奖励制度执行，只可享受一个等级奖励。":
    "レベルに応じた成長基準と報酬システムが毎月実装され、レベル報酬は1つしか楽しめません。",
  渠道生成: "チャネル生成",
  创建: "作成",
  渠道名称: "チャンネル名",
  注册人数: "登録者数",
  浏览人数: "視聴者",
  构建状态: "ビルドステータス",
  禁用: "無効",
  启用: "有効",
  查看: "小切手",
  创建渠道: "チャネルを作成",
  创建成功: "正常に作成されました",
  操作成功: "成功した操作",
  渠道详情: "チャンネルの詳細",
  邀请码: "招待コード",
  访问人数: "来場者数",
  渠道地址: "チャンネルアドレス",
  我的福利: "私の利点",
  充值福利: "リチャージ特典",
  当前流水: "現在の流れ",
  如何参与: "参加方法",
  币种充值: "通貨リチャージ",
  充值福利中领取福利: "トップアップ特典から特典を受け取る",
  "规则：充值福利自愿领取，有效期为充值后的24小时内，过期无效，领取后将暂时锁定提现功能，当流水达到后即可解锁提现。":
    "ルール：リチャージ特典の受け取りは任意で、有効期間はリチャージ後24時間以内、有効期限を過ぎると無効、受け取り後は現金引き出し機能が一時的にロックされ、現金引き出しが可能になります。ターンオーバーに達するとロックが解除されます。",
  失效日期: "有効期限",
  "暂无福利领取，充值后领取":
    "受け取る特典はまだありません。充電後に受け取ります",
  参与: "参加",
  充值赠送: "リチャージギフト",
  "领取*%的赠送": "{0}% のギフトを受け取る",
  去领取: "集める",
  VIP奖励: "VIP特典",
  "当前可领取*USDT，是否确认领取":
    "現在 {0}USDT を受け取ることができますが、請求を確認できますか?",
  "领取后将临时锁定提现功能，当您的流水到达*USDT后即可解除锁定":
    "請求後、引き出し機能は一時的にロックされ、売上高が{0}USDTに達するとロックが解除されます",
  充值送大礼: "チャージして大きなギフトを手に入れよう",
  "存入越多，送越多！": "入金すればするほど、より多くを得ることができます!",
  无效: "無効",
  有效: "効率的",
  总存金额: "総入金額",
  提示: "ヒント",
  "总输赢，净输赢中正数表示平台盈利，负数表示亏损，每天数据只做参考，并不做实际佣金派发标准。":
    "総勝敗数と純勝敗数の正数はプラットフォームの利益を表し、負数は損失を表します.毎日のデータは参考用であり、実際の手数料分配の基準とはなりません.",
  "净盈亏：总盈亏-用户返水": "純利益と損失: 総利益と損失 - ユーザー リベート",
  盈利方: "お得パーティー",
  代理: "演技",
  客户: "クライアント",
  平局: "描く",
  平台: "プラットホーム",
  "已提交审核，请耐心等待": "審査のために送信しました。しばらくお待ちください",
  充值日期: "充電日",
  平台本月总输赢: "今月のプラットフォームの総勝ち負け",
  KOL招募合作: "KOL採用協力",
  "平台现在开放【KOL招募活动】，只要您有社群媒体号，就可以和平台享受分红一次性推广客户，就可以享受终生收益。":
    "プラットフォームがオープンしました [KOL Recruitment Event]、ソーシャル メディア アカウントを持っている限り、顧客を促進するためのプラットフォームで 1 回限りのボーナスを享受でき、生涯にわたるメリットを享受できます。",
  级别: "レベル",
  平台利润返佣: "プラットフォームの利益のリベート",
  佣金案例: "コミッションケース",
  交易项目: "取引項目",
  "期权交易、合约交易、足球游戏": "オプション取引、契約取引、サッカーゲーム",
  报名方式: "登録方法",
  点击KOL招募报名: "KOL採用登録をクリック",
  "欢迎加入我们的团队，平台全面扶持您建立属于自己的用户体系，最高可得*的佣金，我们期待您加入。":
    "私たちのチームにようこそ。プラットフォームは、独自のユーザーシステムを確立することを完全にサポートし、最高の{0}コミッションを得ることができます。あなたの参加をお待ちしています。",
  输入联系方式: "連絡先情報を入力してください",
  最低活跃人数: "最小アクティブ数",
  "如：本月活跃人数≥*并且本月平台总输赢≥*USDT，您属于等级*，即可得到*%的佣金。":
    "例: 今月のアクティブ ユーザー数 ≥ {0} で、今月のプラットフォームの総勝ち負け ≥ {1}USDT の場合、あなたはレベル {2} に属しており、{3}% のコミッションを得ることができます。",
  比分竞猜: "スコア？クイズ",
  豪礼相赠: "おみやげを贈る",
  足球活动: "サッカー活動",
  圣诞节活动: "クリスマスイベント",
  "您参加了活动，临时锁定提现功能，还需*USDT流水就可以解除锁定。":
    "イベントに参加して、一時ロックキャッシュ機能を実行し、USDT流水を必要とするとロックを解除できます。",
  剩余流水: "ざんりゅうすいりゅう",
  助力足球: "サッカーを応援する",
  佣金累计: "合計手数料",
  有效投注: "有効な賭け",
  今日: "今日",
  今日返水: "今日のリベート",
  VIP返水: "VIP リベート",
  返水记录: "リベート実績",
  成员信息: "会員情報",
  基本信息: "基本情報",
  钱包余额: "ウォレット残高",
  投注信息: "賭け情報",
  返水: "リベート",
  总下注: "合計ベット",
  今日输赢: "今日勝ったり負けたり",
  下注动态: "ベッティングダイナミクス",
  返水奖励: "リベートボーナス",
  分红金额: "配当金額",
  返水支出: "リベートの支払い",
  总返水: "合計リベート",
  流水总额: "総取引高",
  返水总额: "合計リベート",
  返水详情: "リベートの詳細",
  日流水: "毎日の水",
  "平台根据你下级每日流水进行额外返水奖励,奖励每日新加坡时间00：00进行派发至赏金账户":
    "プラットフォームは、部下の毎日の売上高に基づいて追加のリベート報酬を提供し、報酬はシンガポール時間の毎日 00:00 に報酬アカウントに分配されます",
  "申请成功，等待审核": "申請は成功し、審査待ちです",
  "我出本金，盈利共分享": "私は元本を支払い、利益を分配します",
  最高分红: "最高配当",
  投资大师比赛: "投資マスターコンペティション",
  "我出本金，你盈利": "私は元本を払います、あなたは利益を得ます",
  共分享: "共有",
  最高分红可得: "利用可能な最大配当",
  "新用户专属福利来袭，免费赠送$*，领取后即可投资平台任何项目，盈利后立即可提取。":
    "新規ユーザー限定の特典があり、${0} は無料です。受け取った後はプラットフォーム上の任意のプロジェクトに投資でき、利益が出たらすぐに引き出すことができます。",
  报名领取: "サインアップして受け取る",
  已领取: "受け取った",
  审核驳回: "審査拒否",
  驳回原因: "却下理由",
  活动运行周期: "アクティビティ実行サイクル",
  "申请成功后起至*天内完成超额收益。":
    "申請が成功した後、超過収入は{0}日以内に完了します。",
  分红比: "配当率",
  "*日获得盈利后，可获得*%的收益额。":
    "{0} 日に利益を上げた後、利益の {1}% を得ることができます。",
  参与条件: "参加条件",
  "俄罗斯、土耳其地区的用户，且未参与。":
    "ロシアとトルコのユーザーは参加しませんでした。",
  计算项目: "計算項目",
  "合约、体育、期权": "契約、スポーツ、オプション",
  我的投资: "私の投資",
  参与天数: "参加日",
  累计下注: "累積ベット",
  累计盈亏: "累計損益",
  预计可分红: "配当金の支払いを期待",
  常见问题: "よくある問題",
  什么是平台出资: "プラットフォームファンディングとは",
  "平台根据部分国家的用户，免费提供资金让用户去投项目。":
    "一部の国のユーザーによると、プラットフォームはユーザーがプロジェクトに投資するための無料の資金を提供します。",
  怎么获取平台出资的福利: "プラットフォーム貢献の恩恵を受ける方法",
  "您是指定国家的用户即可，点击上方报名按钮，当平台审核完成后将会把*USDT转入当前账户下的赏金账户，您可划转至其他账户下进行投资。":
    "指定された国のユーザーになるだけで、上記の登録ボタンをクリックすると、{0}USDT はプラットフォームの審査が完了した後、現在のアカウントの下のバウンティ アカウントに転送され、他のアカウントに転送して投資することができます。",
  什么是分红: "配当とは",
  "分红指在规定时间内，收益额到达100%后，可分得超额收益的50%。例如：领取100USDT资金，收益额度是120%。":
    "配当とは、一定期間内に収入が 100% に達した後、超過収入の 50% を分配できることを意味します。 例: 100USDT 資金を受け取る場合、収入額は 120% です。",
  "如何取得分红？": "配当金を受け取るには？",
  "活动周期每*天1次，活动结束后进行核算，满足活动要求后分红派发至赏金账户。若你未达到活动要求，系统将自动清除你的收益额和平台的出资。":
    "活動サイクルは{0}日ごとに1回で、活動終了後に計算され、活動条件を満たすと報奨金口座に配当が分配されます。 アクティビティの要件を満たしていない場合、システムは収入とプラットフォームへの貢献を自動的にクリアします。",
  活动规则: "活動ルール",
  "参与的账号需进行KYC认证，每个账户仅限一份福利。":
    "参加アカウントは KYC 検証を受ける必要があり、各アカウントは 1 つの特典に限定されます。",
  "参与账号的KYC需要指定的国家方可参与，其他地区无权限参与，请核对活动国家与您的国家是否一致。":
    "参加アカウントの KYC には、指定された国が参加する必要があり、他の地域は参加する権限がありません。アクティブな国があなたの国と一致しているかどうかを確認してください。",
  "参与活动成功后，账户将临时锁定您的提现功能，当完成活动后即可解除您的提现功能。":
    "アクティビティに正常に参加すると、アカウントは一時的に出金機能をロックし、アクティビティが完了すると出金機能が解放されます。",
  "请遵守平台活动规则，若发现作弊、利用系统漏洞进行获利，平台将会长期冻结您的账户下所有资金。":
    "プラットフォームのアクティビティ ルールを遵守してください.システムの抜け穴を利用して不正行為を行ったり、利益を得たりした場合、プラットフォームはアカウントのすべての資金を長期間凍結します.",
  平台出资: "プラットフォームへの投資",
  平台出资收回: "プラットフォーム投資回収",
  投资大师奖励: "投資マスター賞",
  请下载APP添加收款方式: "アプリをダウンロードして支払い方法を追加してください",
  请下载APP进行身份验证: "本人確認のためにアプリをダウンロードしてください",
  请下载APP参与: "アプリをダウンロードして参加してください",
  技术指标: "テクニカル指標",
  主图: "メイン画像",
  副图: "サブピクチャー",
  新注册人数: "新規登録者",
  老用户存款人数: "古いユーザーの預金",
  存款人数: "預金者数",
  取款人数: "出金回数",
  投注人数: "ベッターの数",
  "除印度尼西亚、印度、孟加拉国，且未参与过的用户。":
    "インドネシア、インド、バングラデシュ、および参加していないユーザーを除く。",
  市场动态: "市場動向",
  外汇合约: "外国為替契約",
  盈亏比: "損益率",
  委托价: "注文価格",
  可用余额: "利用可能残高",
  持仓额: "ポジション量",
  强平价: "強力なパリティ",
  修改: "改訂",
  修改价位: "価格を変更する",
  外汇: "外国為替",
  外汇账户: "外国為替口座",
  我的交易: "私の取引",
  未设置: "設定されていません",
  超出最大可设数值: "設定可能な最大値を超えています",
  超出最小可设数值: "設定可能な最小値を超えています",
  止盈超出最小可设数值: "テイクプロフィットが設定可能な最小値を超えています",
  止损超出最大可设数值: "ストップロスが設定可能な最大値を超えています",
  止盈超出最大可设数值: "テイクプロフィットが設定可能な最大値を超えています",
  止损超出最小可设数值: "ストップロスが設定可能な最小値を超えています",
  挖矿: "マイニング",
  交易账户: "取引口座",
  买涨: "買い占めます",
  买跌: "買うか売るか",
  请输入正确的银行卡信息: "正しい銀行カード情報を入力してください",
  联系在线客服: "オンラインカスタマーサービスにお問い合わせください",
  法币交易请联系在线客服:
    "法定通貨取引については、オンラインカスタマーサービスにお問い合わせください。",
  提交订单: "注文を送信",
  "支付过程如有疑问,请联系在线客服":
    "支払いプロセスについてご質問がある場合は、オンライン カスタマー サービスにお問い合わせください。",
  彩金赠送: "色金贈呈",
  在线客服: "オンラインサービス",
  最少投资: "最低投資額",
  "提交时间:": "提出時間:",
  提现拒绝: "出金が拒否されました",
  认证拒绝: "認証が拒否されました",
  认证通过: "認証に合格しました",
  请输入正确的交易额度: "正しい取引金額を入力してください",
  最大下注金额: "最大ベット額",
  手机号: "電話番号",
  邮箱注册: "メール登録",
  手机号注册: "携帯電話番号の登録",
  查询: "お問い合わせ",
  手机号登录: "携帯電話番号ログイン",
  邮箱登录: "メールログイン",
  请输入数量: "数量を入力してください",
  可用数量: "利用可能な数量",
  钱包登录: "ウォレットへのログイン",
  请输入正确的邀请码: "正しい招待コードを入力してください",
  "请输入邀请码(必填)": "招待コードを入力してください（必須）",
  输入正确的金额: "正しい金額を入力してください",
  法币充值: "法定通貨でリチャージ",
  卢比充值: "ルピー充電",
  请输入法币: "法定通貨を入力してください",
  请输入IFSC: "IFSCを入力してください",
  "银行编码(选填)": "銀行コード（オプション）",
  请输入银行编码: "銀行コードを入力してください",
  请输入大于8位数的密码: "8桁以上のパスワードを入力してください",
  添加成功: "正常に追加されました",
  "60秒": "60秒",
  "180秒": "180秒",
  "300秒": "300秒",
  "2次密码不一致": "2 つのパスワードが矛盾しています",
  输入提币数量: "出金額を入力してください",
  图片格式不正确: "画像フォーマットが正しくありません",
  图片大于20M: "画像が20MBを超えています",
  请设置委托价格: "委託価格を設定してください",
  输入资金密码: "資金パスワードを入力してください",
  验证码错误: "認証コードエラー",
  充值拒绝: "リチャージが拒否されました",
  请输入SSN: "SSN を入力してください",
  合约交易: "契約取引",
  结算完成: "決済完了",
  继续下单: "注文を続ける",
  最低购买: "最低購入額",
  最高购买: "最高額の購入",
  限价: "リミット価格",
  买入价格: "購入価格",
  买入量: "購入数量",
  卖出价格: "販売価格",
  卖出量: "販売数量",
  买入: "購入",
  卖出: "販売",
  订单创建成功: "注文が正常に作成されました",
  币币买入支出: "暗号通貨購入支出",
  币币买入支出退还: "暗号通貨購入支出の返金",
  币币买入获得: "暗号通貨購入で得たもの",
  币币卖出支出: "暗号通貨販売支出",
  币币卖出支出退还: "暗号通貨販売支出の返金",
  币币卖出获得: "暗号通貨販売で得たもの",
  币币交易手续费: "暗号通貨取引手数料",
  请输入限价: "リミット価格を入力してください",
  成交: "完了",
  等待成交: "完了を待っています",
  交易完成: "取引が完了しました",
  被取消: "キャンセルされました",
  交易时间: "取引時間",
  法币交易: "法定通貨取引",
  法币出售: "法定通貨販売",
  两次密码不一致: "パスワードが一致しません",
  再次输入账户密码: "アカウントのパスワードを再入力してください",

  美国: "アメリカ合衆国",
  韩国: "韓国",
  阿尔巴尼亚: "アルバニア",
  津巴布韦: "ジンバブエ",
  赞比亚: "ザンビア",
  也门: "イエメン",
  美属维尔京群岛: "USバージン諸島",
  英属处女群岛: "イギリスのバージン諸島",
  越南: "ベトナム",
  委内瑞拉: "ベネズエラ",
  瓦努阿图: "バヌアツ",
  乌兹别克斯坦: "ウズベキスタン",
  乌拉圭: "ウルグアイ",
  英国: "英国",
  阿拉伯联合酋长国: "アラブ首長国連邦",
  乌克兰: "ウクライナ",
  乌干达: "ウガンダ",
  特克斯和凯科斯群岛: "トルコ諸島とカイコス諸島",
  土库曼斯坦: "トルクメニスタン",
  土耳其: "Türkiye",
  突尼斯: "チュニジア",
  特立尼达和多巴哥: "トリニダード・トバゴ",
  汤加: "トンガ",
  多哥: "持ち帰り",
  东帝汶: "ティモールレステ",
  泰国: "タイ",
  坦桑尼亚: "タンザニア",
  塔吉克斯坦: "タジキスタン",
  中国台湾: "台湾、中国",
  叙利亚: "シリア",
  瑞士: "スイス",
  瑞典: "スウェーデン",
  斯威士兰: "スワジランド",
  苏里南: "スリナム",
  苏丹: "スーダン",
  斯里兰卡: "スリランカ",
  西班牙: "スペイン",
  南非: "南アフリカ",
  索马里: "ソマリア",
  所罗门群岛: "ソロモン諸島",
  斯洛文尼亚: "スロベニア",
  斯洛伐克: "スロバキア",
  "圣马丁岛（荷兰部分）": "セントマーチン（オランダの一部）",
  新加坡: "シンガポール",
  塞拉利昂: "シエラレオネ",
  塞舌尔: "セイシェル",
  塞尔维亚: "セルビア",
  塞内加尔: "セネガル",
  沙特阿拉伯: "サウジアラビア",
  圣多美和普林西比: "サン・トメとプリンシペ",
  圣马力诺: "サンマリノ",
  萨摩亚: "サモア",
  圣克里斯托弗和尼维斯: "セントクリストファーとネビス",
  圣文森特和格林纳丁斯: "聖ヴィンセントとグレナジン",
  圣彼埃尔和密克隆岛: "聖ピエールとミケロン島",
  圣露西亚: "セントルシア",
  圣基茨和尼维斯: "セントキッツとネビス",
  卢旺达: "ルワンダ",
  俄罗斯: "ロシア",
  罗马尼亚: "ルーマニア",
  留尼汪: "再会",
  刚果共和国: "コンゴ共和国",
  卡塔尔: "カタール",
  波多黎各: "プエルトリコ",
  葡萄牙: "ポルトガル",
  波兰: "ポーランド",
  菲律宾: "フィリピン",
  秘鲁: "ペルー",
  巴拉圭: "パラグアイ",
  巴布亚新几内亚: "パプアニューギニア",
  巴拿马: "パナマ",
  巴勒斯坦: "パレスチナ",
  帕劳: "パラオ",
  巴基斯坦: "パキスタン",
  阿曼: "オマーン",
  挪威: "ノルウェー",
  尼日利亚: "ナイジェリア",
  尼日尔: "ニジェール",
  尼加拉瓜: "ニカラグア",
  新西兰: "ニュージーランド",
  新喀里多尼亚: "ニューカレドニア",
  荷属安德列斯群岛: "オランダアンドレス諸島",
  荷兰: "オランダ",
  尼泊尔: "ネパール",
  纳米比亚: "ナミビア",
  缅甸: "ミャンマー",
  莫桑比克: "モザンビーク",
  摩洛哥: "モロッコ",
  蒙特塞拉特岛: "モンセラット島",
  黑山: "モンテネグロ",
  蒙古: "モンゴル",
  摩纳哥: "モナコ",
  摩尔多瓦: "モルドバ",
  墨西哥: "メキシコ",
  马约特: "Mayot",
  毛里求斯: "モーリシャス",
  毛里塔尼亚: "モーリタニア",
  马里亚纳群岛: "マリアナ諸島",
  马提尼克: "マルティニーク",
  马耳他: "マルタ",
  马里: "マリ",
  马尔代夫: "モルディブ",
  马来西亚: "マレーシア",
  马拉维: "マラウイ",
  马达加斯加: "マダガスカル",
  马其顿: "マケドニア",
  中国澳门: "中国マカオ",
  卢森堡: "ルクセンブルク",
  立陶宛: "リトアニア",
  列支敦士登: "リヒテンシュタイン",
  利比亚: "リビア",
  利比里亚: "リベリア",
  莱索托: "レソト",
  黎巴嫩: "レバノン",
  拉脱维亚: "ラトビア",
  老挝: "ラオス",
  吉尔吉斯斯坦: "キルギスタン",
  科威特: "クウェート",
  基里巴斯: "キリバティ",
  肯尼亚: "ケニア",
  哈萨克斯坦: "カザフスタン",
  约旦: "ヨルダン",
  日本: "日本",
  牙买加: "ジャマイカ",
  象牙海岸: "コートジボワール",
  意大利: "イタリア",
  以色列: "イスラエル",
  爱尔兰: "アイルランド",
  伊拉克: "イラク",
  伊朗: "イラン",
  印度尼西亚: "インドネシア",
  印度: "インド",
  冰岛: "アイスランド",
  匈牙利: "ハンガリー",
  中国香港: "香港、中国",
  洪都拉斯: "ホンジュラス",
  海地: "ハイチ",
  圭亚那: "ガイアナ",
  几内亚比绍共和国: "ギニア - ビッソー共和国",
  几内亚: "ギニア",
  危地马拉: "グアテマラ",
  关岛: "グアム",
  瓜德罗普岛: "グアドループ",
  格林纳达: "グレネダ",
  格陵兰岛: "グリーンランド",
  希腊: "ギリシャ",
  直布罗陀: "ジブラルタル",
  加纳: "ガーナ",
  德国: "ドイツ",
  格鲁吉亚: "ジョージア",
  冈比亚: "ガンビア",
  加蓬: "ガボン",
  法属波利尼西亚: "フランスのポリネシア",
  法属圭亚那: "フランスのギアナ",
  法国: "フランス",
  芬兰: "フィンランド",
  斐济: "フィジー",
  法罗群岛: "フェロー諸島",
  埃塞俄比亚: "エチオピア",
  爱沙尼亚: "エストニア",
  厄立特里亚: "エリトリア",
  赤道几内亚: "赤道ギニア",
  萨尔瓦多: "エルサルバドル",
  埃及: "エジプト",
  厄瓜多尔: "エクアドル",
  多米尼加共和国: "ドミニカ共和国",
  多米尼加: "ドミニカ人",
  吉布提: "djibouti",
  丹麦: "デンマーク",
  捷克: "チェコ共和国",
  塞浦路斯: "キプロス",
  库拉索: "キュラソー",
  古巴: "キューバ",
  克罗地亚: "クロアチア",
  哥斯达黎加: "コスタリカ",
  科特迪瓦: "コートジボワール",
  库克群岛: "料理島",
  科摩罗: "コモロ",
  哥伦比亚: "コロンビア",
  智利: "チリ",
  乍得: "チャド",
  中非共和国: "中央アフリカ共和国",
  佛得角: "ケープヴェルデ",
  开曼群岛: "ケイマン諸島",
  开普: "カイプ",
  加拿大: "カナダ",
  喀麦隆: "カメルーン",
  柬埔寨: "カンボジア",
  布隆迪: "ブルンジ",
  布基纳法索: "ブルキナファソ",
  保加利亚: "ブルガリア",
  文莱: "ブルネイ",
  巴西: "ブラジル",
  博茨瓦纳: "ボツワナ",
  波斯尼亚和黑塞哥维那: "ボスニアとヘルツェゴビナ",
  玻利维亚: "ボリビア",
  不丹: "ブータン",
  百慕大群岛: "バミューダ諸島",
  贝宁: "ベニン",
  伯利兹: "ベリーズ",
  比利时: "ベルギー",
  白俄罗斯: "ベラルーシ",
  巴巴多斯: "バルバドス",
  孟加拉国: "バングラデシュ",
  巴林: "バーレーン",
  巴哈马: "バハマ",
  阿塞拜疆: "アゼルバイジャン",
  奥地利: "オーストリア",
  澳大利亚: "オーストラリア",
  阿鲁巴: "アルバ",
  亚美尼亚: "アルメニア",
  阿根廷: "アルゼンチン",
  安提瓜和巴布达: "アンティグアとバーブーダ",
  安圭拉: "アンギラ",
  安哥拉: "アンゴラ",
  安道尔: "アンドラ",
  美属萨摩亚: "アメリカのサモア",
  阿尔及利亚: "アルジェリア",
  中国: "中国",

  日收益: "日収益",
  "30天预期收益": "30日予想収益",
  英伟达高速矿机: "NVIDIA高速マイニング機",
  去投资: "投資に行く",
  新币榜: "新コインランキング",
  主题: "テーマ",
  立即探索: "すぐに探索する",
  等您来: "あなたを待っています",
  最新活动: "最新イベント",
  货币划转: "通貨移転",
  提现钱包: "出金ウォレット",
  加密合约: "暗号化コントラクト",
  外汇期货: "外国為替先物",
  定期: "定期",
  探索产品: "製品を探索する",
  稳健型: "安定型",
  高收益: "高収益",
  期货账户: "先物口座",
  时间线: "タイムライン",
  收藏: "お気に入り",
  委托订单: "委託注文",
  最新交易: "最新取引",
  深度图: "デプスチャート",
  标记价格: "マーク価格",
  "24h最高价": "24時間最高価格",
  "24h成交量": "24時間出来高",
  "24h最低价": "24時間最安価格",
  "24h成交额": "24時間取引高",
  "价格(USDT)": "価格(USDT)",
  "数量(ETH)": "数量(ETH)",
  看空: "空売り",
  余额不足: "残高不足",
  最低购买: "最低購入額",
  最高购买: "最高購入額",
  下单成功: "注文成功",
  平仓成功: "決済成功",
  请输入正确的平仓数量: "正しい決済数量を入力してください",
  加仓成功: "増枠成功",
  请输入正确的加仓金额: "正しい増枠金額を入力してください",
  收藏成功: "お気に入り登録成功",
  取消收藏成功: "お気に入り解除成功",
  日收益率: "日収益率",
  轻松理财: "手軽に資産運用",
  立即申购: "すぐに申し込む",
  申购日期: "申込日",
  加密货币: "暗号資産",
  交割合约: "受渡しコントラクト",
  最小投资: "最低投資額",
  委托: "委託",
  "当指数价格触达时，将会触发委托平仓":
    "指数価格が到達した場合、委託決済がトリガーされます",
  预计盈利: "予想利益",
  最大投资: "最高投資額",
  现货交易: "暗号通貨取引",
  输入交易金额: "取引金額を入力してください",
  "可用额度：": "利用可能枠：",
  提现货币: "出金通貨",
  期货合约: "先物コントラクト",
  加密币永续: "暗号資産永続",
  外汇永续: "FX永続",
  期权账户: "オプション口座",
  夜间模式: "ナイトモード",
  未结盈亏: "未決済損益",
  超额收益: "超過収益",
  "安全策略，低买高卖": "安全策、低買高売",
  投资金额应为: "投資金額は",
  总收益率: "総収益率",
  赎回成功: "成功を請け出す",
  快捷卖币: "クイック売却",
  修改止盈止损: "利確/損切りを変更",
  白皮书: "白書",

  托管资金: "運用資金",
  托管中: "運用中",
  预计日收益: "予想日次収益",
  累计收益: "累計収益",
  周期: "期間",
  日收益: "日次収益",
  限额: "上限",
  立即托管: "今すぐ運用",
  "已鎖定 請聯繫客服":
    "ロックされています。カスタマーサービスにお問い合わせください",
  产品列表: "商品一覧",
  规则: "ルール",
  创建订单: "注文作成",
  产品名称: "商品名",
  托管周期: "運用期間",
  等级限制: "レベル制限",
  托管金额: "運用金額",
  限额: "上限",
  余额: "残高",
  购买日: "購入日",
  起息日: "利息開始日",
  派息时间: "配当時間",
  每天: "毎日",
  计息结束日: "利息終了日",
  每日收益: "日次収益",
  预计收益: "予想収益",
  "收益将自动发送至您的余额账户;": "収益は自動的に残高口座へ送金されます;",
  "您的资金没有任何风险;": "資金には一切のリスクはありません;",
  "365*24小时不断地工作;": "365日24時間稼働しています;",
  托管中: "運用中",
  结束: "終了",
  今日收益: "本日の収益",
  剩余周期: "残り期間",
  进行中: "進行中",
  已发放: "支払い済み",
  信誉分: "評判のポイント",

  复制成功: "コピー成功",
  VIP权益: "VIP特典",
  旧密码: "旧パスワード",
  请输入旧密码: "旧パスワードを入力してください",
  "忘记旧密码请联系客服重置。":
    "旧パスワードを忘れた場合は、カスタマーサービスにお問い合わせの上、リセットしてください。",
  去升级: "アップグレード",
  描述: "説明",
  实际存款金额: "実際の入金額",
  升级礼金: "アップグレードボーナス",
  隔夜利息: "スワップポイント",
  自动结算: "自動決済",
  等级规则: "レベルルール",
  "WEB3.0币持有数据收益": "WEB3.0コイン保有データ利回り",
  总生产: "総生産量",
  有效节点: "有効ノード",
  参与人: "参加者",
  用户收益: "ユーザー利回り",
  "流动性WEB3.0输出": "流動性WEB3.0アウトプット",
  总资产: "総資産",

  ETHAI持有数据收益: "ETHAI保有データ利回り",
  AI量化流动性: "AI量的流動性",
  现货买入手续费: "現物買入手数料",
  现货支出: "現物支出",
  现货资金费率: "現物資金調達レート",
  现货卖出手续费: "現物売入手数料",
  现货收入: "現物収入",
  外汇合约支出: "外国為替契約支出",
  外汇合约买入手续费: "外国為替契約買入手数料",
  外汇合约资金费率: "外国為替契約資金調達レート",
  外汇合约卖出手续费: "外国為替契約売入手数料",
  外汇合约收入: "外国為替契約収入",
  理财购买: "資産運用購入",
  VIP理财日收益: "VIP資産運用日次利回り",
  VIP理财隔夜利息: "VIP資産運用オーバーナイト金利",
  VIP本金返还: "VIP元本返還",
  VIP彩金发放: "VIPボーナス支給",
  VIP彩金抵扣: "VIPボーナス控除",
  隔夜利息: "オーバーナイト金利",
  设置资产密码: "資産パスワード設定",

  锁仓挖矿: "ロックマイニング",
  一站式理财服务: "ワンストップ資産運用サービス",
  产品: "商品",
  客服中心: "カスタマーサービスセンター",
  贷款: "ローン",
  挖矿赚不停: "マイニングで継続的に収益",
  "锁仓挖矿是通过将USDT (USD:1USDT=1USD) 托管给平台超算力矿机，在平台矿池中进行挖矿收益。":
    "ロックマイニングとは、USDT (USD:1USDT=1USD) をプラットフォームの高性能マイニングマシンに預け、プラットフォームのマイニングプールで収益を得る仕組みです。",
  产品优势: "商品の利点",
  随存随取: "いつでも入出金可能",
  锁仓周期: "ロック期間",
  每日下发: "毎日配布",
  随机空投: "ランダムエアドロップ",
  "100%资金安全保障": "100%資金安全保証",
  "100%节假日收益不间断": "祝日でも100%収益が継続",
  成功锁仓后当天产出: "ロック成功当日から収益発生",
  关于违约金: "違約金について",
  "若您希望转出未到期的本金,则会产生违约金,违约金=违约结算比例*剩余天数*锁仓金额.":
    "満期前に元本を引き出す場合、違約金が発生します。違約金＝違約精算率×残り日数×ロック金額。",
  "举例:此锁仓挖矿的违约结算比例为5%,剩余3天到期,锁仓金额为10000U《USDT/USD》,则违约金=5%*3*10000=1500U,实际退回本金为15000U-1500U":
    "例：このロックマイニングの違約精算率は5%、残り3日、ロック金額は10000U（USDT/USD）の場合、違約金＝5%×3×10000＝1500U、実際の返金額は15000U-1500Uです。",
  收益计算: "収益計算",
  "平台有多种锁仓挖矿理财产品供使用者选择,收益计算如下,举例:":
    "プラットフォームには複数のロックマイニング金融商品があります。収益計算は以下の通りです：",
  "会员在平台锁仓10000U(USDT,USD),如选择了周期为7天,日产出为锁仓金额的0.7%~1.8%的理财产品,则每天产出如下":
    "ユーザーが10000U（USDT, USD）をロックし、7日間で日利0.7%～1.8%の商品を選択した場合、1日の収益は以下の通りです：",
  "最低:10000Ux0.7%=70U;": "最低：10000U×0.7%=70U;",
  "最高:10000Ux1.8%=180U;": "最高：10000U×1.8%=180U;",
  "即7天后可获得490U~1260U的收益,收益每日下发,锁仓本金到期后,自动转入您的资金账户.":
    "7日後に490U～1260Uの収益を得られます。収益は毎日配布され、満期後に元本は自動的に資金口座へ送金されます。",
  正在托管的资金: "運用中の資金",
  签到: "チェックイン",
  锁仓订单: "ロック注文",
  预计今日收益: "本日の予想収益",
  累计收益: "累計収益",
  托管中的订单: "運用中の注文",
  单笔最少: "最低注文額",
  单笔最多: "最大注文額",
  日收益率: "日利回り",
  说明: "説明",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出<br>3.当天的收益会统一在次日GMT+8时间00:00-00:10内派发.":
    "1. データ統計はGMT+8基準です<br>2. 日次収益は00:00～23:59（GMT+8）の決済済み注文を基に計算されます<br>3. 当日の収益は翌日00:00～00:10（GMT+8）に配布されます。",
  知道了: "了解",
  锁仓: "ロック",
  派息时间: "配当時間",
  每日: "毎日",
  托管资金: "預かり資金",
  到期返回: "満期返還",
  提前赎回: "早期償還",
  预计收益: "予想収益",
  认购: "申込",
  热门: "人気",
  数字货币: "暗号資産",
  贵金属: "貴金属",
  大宗商品: "コモディティ",
  持仓明细: "ポジション詳細",
  历史明细: "履歴",
  当前价: "現在価格",
  "↑买涨": "↑上昇買い",
  "↓买跌": "↓下落買い",
  显示全部: "すべて表示",
  买入金额: "購入金額",
  方向: "方向",
  收益: "利益",
  预期收益: "予想利益",
  估用保证金: "推定証拠金",
  确认下单: "注文確定",
  锁定: "ロック中",
  账户总资产: "総資産",
  明细: "詳細",
  今日收益: "本日の収益",
  仓位保证金: "ポジション証拠金",
  持有仓位: "保有ポジション",
  "锁定金额=所有锁仓挖矿中未完成订单的金额总和":
    "ロック金額＝すべての未完了ロックマイニング注文の合計",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出":
    "1. データ統計はGMT+8基準です<br>2. 日次収益は決済済み注文に基づいて計算されます",
  充值方式: "入金方法",
  银行汇款: "銀行振込",
  "银行汇款请联系客服进行操作!":
    "銀行振込はカスタマーサポートにご連絡ください！",
  提款方式: "出金方法",
  "银行提款请联系客服进行操作!":
    "銀行出金はカスタマーサポートにご連絡ください！",
  资金明细: "資金明細",
  提现记录: "出金履歴",
  拒绝: "拒否",
  通过: "承認",
  拒绝原因: "拒否理由",

  消息公告: "お知らせ",
  订单: "注文",
  个人中心: "マイページ",
  "未到期赎回需支付一定的违约金!": "満期前の解約には違約金が発生します。",

  请输入区号: "市外局番を入力してください",
  "请选择国家/地区": "国/地域を選択してください",

  今日开盘: "今日の始値",
  昨日收盘: "昨日の終値",

  实名认证即送: "本人確認完了後すぐに受け取る",
  立即认证: "今すぐ認証",
  新用户礼包: "新規ユーザーギフトパック",
  完成新人任务领取: "新規ユーザータスクを完了して受け取る",
  认证: "認証",
  时间周期: "期間",
  支付金额: "支払金額",
  已平仓: "決済済み",
  "MGBX 新用户欢迎礼包：每位用户最多可获得":
    "MGBX 新規ユーザー歓迎ギフトパック：各ユーザーが受け取れる最大額",
  我已经阅读并同意: "私は読み、同意しました",
  隐私政策: "プライバシーポリシー",

  放弃奖励离开: "特典を放棄して終了",
  继续注册: "登録を続ける",
  分钟: "分",

  "请先勾选隐私政策!": "まずはプライバシーポリシーをご確認ください！",
  添加其他到自选: "他の項目をウォッチリストに追加する",
  充值最高可得: "チャージして、最大30,000ドルを獲得しましょう。",

  请输入格式正确的手机号: "有効な携帯電話番号を入力してください。",

  收起: "Collapse",
  上传截图: "Upload screenshot",
  "*充值成功后必须上传充值截图，否则将视为无效存款。": "*After a successful recharge, you must upload the recharge screenshot; otherwise the deposit will be invalid.",
};
// 日语



// WEBPACK FOOTER //
// ./src/lang/ja-jp.js